export default __webpack_public_path__ + "static/media/1099.28399e53.png";